import triggerTypes from '../constants/trigger-types';
import findAllFor from './find-all-for';

const findAllSelectedFor = (element) => findAllFor(element, triggerTypes.SELECT);

export default findAllSelectedFor;
